export const environment = {
  production: true,
  origin: "https://prismdemoapi.vierabuilders.com/",
  api: "api/",
  token: "auth-token",
  notificationMessageCount: "notificationMessageCount",
  colorSheetLimit: 4,
  momentBackendFormat: "MM-DD-YYYY HH:mm:ss",
  displayFormat: "DD-MMM-YYYY",
  serviceRequestDisplayDateFormat: "dd-MMM-yyyy",
  serviceRequestFileCount: "ServiceRequestFileCount",
  serviceRequestFileType: "ServiceRequestFileType",
  ServiceRequestImageSizePerFile: "ServiceRequestImageSizePerFile",
  ServiceRequestVideoSizePerFile: "ServiceRequestVideoSizePerFile",
  CommunityLotPictureSizePerFile: "CommunityLotPictureSizePerFile",
  sectionName: "Flooring",
  tile: "Tile",
  CopilotUrl:
    "https://copilotstudio.microsoft.com/environments/Default-edd5737c-5907-46c9-ab17-40ce0aee2df7/bots/crb20_VIERAWarrantyBuddy/webchat?__version__=2",
  DirectLineTokenEndpoint:
    "https://defaultedd5737c590746c9ab1740ce0aee2d.f7.environment.api.powerplatform.com/powervirtualagents/botsbyschema/crb20_VIERAWarrantyBuddy/directline/token?api-version=2022-03-01-preview",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts